import { useBrandUrl } from "@/hooks";
export const useMedia = (media) => {
    const fallbackPreviewImageUrl = useBrandUrl({
        endpoint: "/shared/images/media/3d-tour-preview-fallback.png",
    });
    const getYoutubeVideoId = () => {
        if (!media || !media.url)
            return null;
        const regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = media.url.match(regex);
        return match && match[2].length === 11 ? match[2] : null;
    };
    const getEmbedUrl = () => {
        if ((media === null || media === void 0 ? void 0 : media.urlType) === "MOVIE") {
            const videoId = getYoutubeVideoId();
            if (!videoId)
                return null;
            return `https://www.youtube-nocookie.com/embed/${videoId}`;
        }
        return null;
    };
    const getPreviewUrl = () => {
        var _a;
        if ((media === null || media === void 0 ? void 0 : media.urlType) === "MOVIE") {
            const videoId = getYoutubeVideoId();
            if (!videoId)
                return null;
            return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        }
        if ((media === null || media === void 0 ? void 0 : media.urlType) === "VIRTUAL_TOUR") {
            return ((_a = media.previewImage) === null || _a === void 0 ? void 0 : _a.url) || fallbackPreviewImageUrl;
        }
        return null;
    };
    return {
        embedUrl: getEmbedUrl(),
        previewUrl: getPreviewUrl(),
    };
};
